import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Briefcase, User } from '@geist-ui/icons';
import { useTheme } from '@geist-ui/core';

const PremiumMobileBottomNav = () => {
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();

    const tabs = [
        { id: 'dashboard', label: 'Portfolio', icon: Briefcase, path: '/direct/dashboard' },
        { id: 'profile', label: 'Profil', icon: User, path: '/direct/profile' },
    ];

    const springConfig = { stiffness: 400, damping: 32, mass: 1 };

    return (
        <div style={{
            position: 'fixed',
            bottom: '24px',
            left: '20px',
            right: '20px',
            zIndex: 9999,
            height: '64px',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'saturate(180%) blur(20px)',
            border: '1px solid rgba(0, 0, 0, 0.04)',
            borderRadius: '40px',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            boxShadow: '0 12px 34px rgba(0, 0, 0, 0.12)',
            transform: 'translateZ(0)',
            willChange: 'transform',
            padding: '0 10px'
        }}>
            {tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                const Icon = tab.icon;

                return (
                    <motion.div
                        key={tab.id}
                        onClick={() => history.push(tab.path)}
                        whileTap={{ scale: 0.9 }}
                        transition={{ type: 'spring', ...springConfig }}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '2px',
                            cursor: 'pointer',
                            color: isActive ? '#000' : '#888',
                            flex: 1,
                            height: '100%',
                            justifyContent: 'center',
                            position: 'relative'
                        }}
                    >
                        <motion.div
                            animate={{ 
                                scale: isActive ? 1.15 : 1,
                                y: isActive ? -1 : 0
                            }}
                            transition={{ type: 'spring', ...springConfig }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <Icon size={20} color={isActive ? '#000' : '#888'} />
                        </motion.div>
                        <span style={{ 
                            fontSize: '10px', 
                            fontWeight: isActive ? 900 : 600,
                            fontFamily: '"Nunito Sans", sans-serif',
                            letterSpacing: '-0.01em',
                            transition: 'color 0.2s ease',
                            marginTop: '2px'
                        }}>
                            {tab.label}
                        </span>
                        {isActive && (
                            <motion.div 
                                layoutId="mobile-nav-dot"
                                style={{
                                    position: 'absolute',
                                    bottom: '6px',
                                    width: '3px',
                                    height: '3px',
                                    borderRadius: '50%',
                                    backgroundColor: '#000'
                                }}
                                transition={{ type: 'spring', ...springConfig }}
                            />
                        )}
                    </motion.div>
                );
            })}
        </div>
    );
};

export default PremiumMobileBottomNav;
